import {FC, memo, PropsWithChildren, useEffect, useRef, useState} from 'react';
import {useCheckLocation, useClickOutside, useScreenSize} from 'ui-kit';
import {useLocation} from 'react-router';
import {Box} from '@chakra-ui/react';
import {api, capitalizeFirstLetter, hasValue} from '@kcast-fe/core';

import {MenuButton, NavigationMenu} from './components';

const MENU_WIDTH = {base: '316px'};

const BaseLayoutFC: FC<PropsWithChildren> = ({children}) => {
  const {data: settings} = api.settings.useSettingsQuery();

  const [isMenuOpened, setIsMenuOpened] = useState(false);

  const menuRef = useRef<HTMLDivElement | null>(null);
  const {is503Page, isOAuthCallbackPage} = useCheckLocation();
  const location = useLocation();
  const {isLessThan768} = useScreenSize();

  const openMenu = () => setIsMenuOpened(true);
  const closeMenu = () => setIsMenuOpened(false);

  useClickOutside(menuRef, () => {
    if (isLessThan768) {
      closeMenu();
    }
  });

  useEffect(() => {
    if (hasValue(settings?.assistant.name)) {
      document.title = capitalizeFirstLetter(settings.assistant.name);
    }
  }, [settings?.assistant?.name]);

  useEffect(() => {
    if (isLessThan768) {
      closeMenu();
    }
  }, [location, isLessThan768]);

  useEffect(() => {
    setIsMenuOpened(!isLessThan768);
  }, [isLessThan768]);

  return is503Page || isOAuthCallbackPage ? (
    <Box w={'100%'} h={'100%'} position={'relative'}>
      <Box h={'100%'}>{children}</Box>
    </Box>
  ) : (
    <Box w={'100%'} h={'100%'} position={'relative'}>
      {isLessThan768 && <MenuButton onOpenMenu={openMenu} />}

      <Box ref={menuRef}>
        <NavigationMenu
          width={isMenuOpened ? MENU_WIDTH : '0'}
          onClose={() => setIsMenuOpened(false)}
        />
      </Box>

      <Box
        h={'100%'}
        pl={isMenuOpened ? {...MENU_WIDTH, smToMd: 0} : 0}
        transition={'padding var(--tr-100-ei)'}
      >
        {children}
      </Box>
    </Box>
  );
};

export const BaseLayout = memo(BaseLayoutFC);
